import type { CopyKey } from './i18n';

// §4: a name belongs to the account, so an address that has one keeps it —
// and the screen that dropped what was typed says so rather than staying mute.
export function keptNameNote(
  typed: string,
  onFile: string | null,
  t: (key: CopyKey) => string,
  where: CopyKey = 'nameKeptWhy',
): string | null {
  if (onFile === null || onFile === typed.trim()) return null;
  return `${t('nameKept')} ${onFile} — ${t(where)}`;
}
